import { Checkbox } from "@mantine/core";
import { useContext, useEffect, useRef } from "react";
import { JourneyContext } from "../../CONTEXT/JourneyStore";
import { editClassName, removeClassName } from "../../HELPERS/ClassNameEditor";

const IndividualBikeRow = ({
  bikeMake,
  bikeModel,
  lockName,
  bikeId,
  lockChecked,
  updateLockChecked,
}) => {
  const ref = useRef(null);
  const [gState, setGState] = useContext(JourneyContext);
  useEffect(() => {
    editClassName(
      ref,
      gState.clickedPayNow &&
        !gState.bikes.find((x) => x.id === bikeId).lockChecked,
      "mantine-Checkbox-error"
    );
  }, [gState]);
  const handleChange = (e) => {
    updateLockChecked(bikeId, e.target.checked);
    if (e.target.checked) {
      removeClassName(ref, "mantine-Checkbox-error");
    }
  };

  const handleRowClick = () => {
    updateLockChecked(bikeId, !lockChecked);
    if (!lockChecked) {
      removeClassName(ref, "mantine-Checkbox-error");
    }
  };

  return (
    <div className="row mt-3 cursorPointer" onClick={handleRowClick}>
      <div className="col-6 col-sm-6 mt-2 ">
        
        <h6 className="lufga-regular wrap">
          {bikeMake} {bikeModel}
        </h6>
      </div>
      <div className="col-4 col-sm-4 mt-2">
        <h6 className="lufga-regular">{lockName}</h6>
      </div>
      <div className="col-2 col-sm-2">
        <Checkbox
          radius="md"
          size="lg"
          id={`lockChecked-${bikeId}`}
          name={`lockChecked-${bikeId}`}
          ref={ref}
          color="velo-blue"
          className="cursorPointer float-end pr-3"
          checked={lockChecked}
          onChange={(e) => handleChange(e)}
        />
      </div>
    </div>
  );
};

export default IndividualBikeRow;
